import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../../data/volumes';
import { SectionCTA } from '../SectionCTA';
export function Volumes() {
  return <section className="w-full bg-navy-900 px-4 py-16 sm:px-6 sm:py-20" data-id="element-344" data-mp="2x19vuhia6gbm">
      <div className="mx-auto max-w-5xl" data-id="element-345" data-mp="2wzgpz4fhs04o">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-go" data-id="element-346" data-mp="2t07t3qp5nm4w">
          📘 What’s inside
        </p>
        <h2 className="mx-auto mt-3 max-w-3xl text-center font-display text-3xl font-bold leading-tight text-white sm:text-4xl" data-id="element-347" data-mp="2o1dcmvenu9ny">
          The 6 DVO Clinical Workflow Builder™ volumes
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-white/70" data-id="element-348" data-mp="2ebk3s25wk8ne">
          Each volume takes one part of complex DVO case planning and turns it into a practical
          workflow you can organize, review and reuse.
        </p>

        <div className="mt-10 space-y-5" data-id="element-349" data-mp="20ahdfd7vkc6o">
          {volumes.map(volume => <article key={volume.numeral} className="overflow-hidden rounded-3xl bg-white/[0.04] ring-1 ring-white/10" data-id="element-350" data-mp="335meh9zb4jm3">
              <div className="flex items-start gap-4 border-b border-white/10 p-5 sm:p-6" data-id="element-351" data-mp="37xxdmam841dl">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-go font-display text-lg font-bold text-white" data-id="element-352" data-mp="2u6966kmx612y">
                  {volume.numeral}
                </span>
                <div className="min-w-0" data-id="element-353" data-mp="3lwn9xo17xx0w">
                  <h3 className="text-[15px] font-extrabold uppercase leading-tight tracking-[0.04em] text-white sm:text-lg" data-id="element-354" data-mp="3qv8g0435jax9">
                    {volume.title}
                  </h3>
                  <p className="mt-1.5 font-display text-[15.5px] italic leading-snug text-go" data-id="element-355" data-mp="3cxs44d236oy4">
                    {volume.headline}
                  </p>
                </div>
              </div>

              <div className="p-5 sm:p-6" data-id="element-356" data-mp="21in0n6u4smdg">
                <p className="text-[14.5px] leading-relaxed text-white/70" data-id="element-357" data-mp="26fn55dbc1h2g">
                  {volume.description}
                </p>
                {volume.extra && <p className="mt-2.5 text-[14.5px] leading-relaxed text-white/70" data-id="element-358" data-mp="7027e2hwe50t">
                    {volume.extra}
                  </p>}

                <p className="mt-5 text-[10.5px] font-bold uppercase tracking-[0.16em] text-white/45" data-id="element-359" data-mp="27iqownwytrs">
                  You’ll get
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-360" data-mp="3peksj8f474g6">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-361" data-mp="3keowbvcnshb6">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-go" aria-hidden="true" data-id="element-362" data-mp="3fflroc0lcd3q" />
                      <span className="text-[14px] leading-snug text-white/85" data-id="element-363" data-mp="3bgd1fh4rexcx">{item}</span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <SectionCTA transformation="All six volumes, organized as one continuous workflow." label="Get all 6 workflow volumes for $27" subline="Plus 5 bonuses and 40+ clinical workflow tools" onDark data-id="element-364" data-mp="2rkjsjstqwk1i" />
      </div>
    </section>;
}